import React, {
  ComponentProps,
  memo,
  MouseEvent,
  ReactNode,
  useState,
} from 'react'

import styled from '@emotion/styled'

import { useHandler } from '@surglogs-app/hooks'
import { File } from '@surglogs-app/icons'
import { TextButton, textEllipsis, Text, Icon } from '@surglogs-app/ui'
import { WrapInToolTip } from '@surglogs-app/ui.tooltip'

const StyledText = styled(Text)`
  max-width: 100%;
  ${textEllipsis()};
`

const onClick = (e: MouseEvent) => {
  if (e && typeof e.stopPropagation === 'function') {
    e.stopPropagation()
  }
}

// cannot extend directly ComponentProps of TextButton because of conditional types
interface FileLinkProps
  extends Pick<ComponentProps<typeof TextButton>, 'variant'> {
  children?: ReactNode
  fileName?: string
  url: string
}

export const FileLink = memo(
  ({
    fileName,
    url,
    children,
    variant = 'primary',
    ...rest
  }: FileLinkProps) => {
    const [tooltip, setTooltipFlag] = useState(false)

    const onFocus = useHandler(() => {
      if (!tooltip) {
        setTooltipFlag(true)
      }
    })

    return (
      <WrapInToolTip {...{ tooltipText: fileName || url, hidden: !tooltip }}>
        <TextButton
          {...{
            as: 'a',
            href: url,
            target: '_blank',
            onClick,
            onFocus,
            onMouseOver: onFocus,
            maw: '100%',
            display: 'inline-flex',
            variant,
            ...rest,
          }}>
          <Icon {...{ icon: File, color: 'inherit', mr: 'sm', va: 'middle' }} />
          <StyledText {...{ color: 'inherit' }}>
            {children || fileName || url}
          </StyledText>
        </TextButton>
      </WrapInToolTip>
    )
  },
)
